import React from "react";
import { NavLink } from "react-router-dom";

const Sidebar: React.FC = () => {
  return (
    <div className="sidebar p-3">

      <nav className="d-flex flex-column gap-2">
        <NavLink to="/admin/dashboard" className="sidebar-link">
          Dashboard
        </NavLink>

        <NavLink to="/admin/enquiries" className="sidebar-link">
          Enquiries
        </NavLink>

        <NavLink to="/admin/users" className="sidebar-link">
          Users
        </NavLink>

        <NavLink to="/admin/fees" className="sidebar-link">
          Fee Collection
        </NavLink>

        <NavLink to="/admin/batch" className="sidebar-link">
          Batch
        </NavLink>

        <NavLink to="/admin/logs" className="sidebar-link">
          Activity Logs
        </NavLink>
        <NavLink to="/admin/contactlist" className="sidebar-link">
         Contact List
        </NavLink>
      </nav>
    </div>
  );
};

export default Sidebar;